export function isBookingCancelled(status: string): boolean {
  return status.toLowerCase() === 'cancelled'
}

export function getDuration(departureDate: string, returnDate: string): number {
  const departure = new Date(departureDate)
  const returnD = new Date(returnDate)

  if (Number.isNaN(departure.getTime()) || Number.isNaN(returnD.getTime())) {
    return 0
  }

  if (departure > returnD) {
    return 0
  }

  const departureDay = new Date(departure.getFullYear(), departure.getMonth(), departure.getDate())
  const returnDay = new Date(returnD.getFullYear(), returnD.getMonth(), returnD.getDate())

  const diffTime = returnDay.getTime() - departureDay.getTime()
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1

  return diffDays
}
